import { cn } from '@commenda/utils';
import moment from 'moment';
import { CALENDAR_BG_WEEKEND, CALENDAR_DIVIDER } from './calendar.constants';
import CalendarDayCell from './CalendarDayCell';
import { DAY_HEADERS } from './calendarGrid';
import { RbcEvent } from './calendar.types';

interface CalendarMonthGridProps {
  rows: Date[][];
  currentMonth: Date;
  eventsByDate: Map<string, RbcEvent[]>;
  onSelectEvent: (event: RbcEvent) => void;
}

const CalendarMonthGrid = ({
  rows,
  currentMonth,
  eventsByDate,
  onSelectEvent,
}: CalendarMonthGridProps) => {
  const currentMonthNum = currentMonth.getMonth();
  const todayDayIndex = new Date().getDay();

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="grid grid-cols-7 shrink-0">
        {DAY_HEADERS.map((day, index) => {
          const isWeekend = index === 0 || index === 6;
          return (
            <div
              key={day}
              className={cn(
                'flex items-center justify-center pb-2 txt-small-bold',
                index === todayDayIndex ? 'text-fg-primary' : 'text-fg-quaternary'
              )}
              style={isWeekend ? { backgroundColor: CALENDAR_BG_WEEKEND } : undefined}
            >
              {day}
            </div>
          );
        })}
      </div>

      <div
        className="grid grid-cols-7 flex-1 min-h-0 border border-border-primary rounded overflow-hidden"
        style={{ gridTemplateRows: `repeat(${rows.length}, 1fr)` }}
      >
        {rows.flatMap((row, rowIndex) =>
          row.map((day, colIndex) => {
            const key = moment(day).format('YYYY-MM-DD');
            const dayEvents = eventsByDate.get(key) ?? [];
            const isOffRange = day.getMonth() !== currentMonthNum;
            const isLastCol = colIndex === 6;
            const isLastRow = rowIndex === rows.length - 1;

            return (
              <div
                key={key}
                className="overflow-hidden"
                style={{
                  borderRight: isLastCol ? 'none' : `1px solid ${CALENDAR_DIVIDER}`,
                  borderBottom: isLastRow ? 'none' : `1px solid ${CALENDAR_DIVIDER}`,
                }}
              >
                <CalendarDayCell
                  date={day}
                  events={dayEvents}
                  isOffRange={isOffRange}
                  onSelectEvent={onSelectEvent}
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default CalendarMonthGrid;
